module.exports = __webpack_public_path__ + "static/media/close.e7441cab.svg";